module.exports = __webpack_public_path__ + "img/dsjxadsj3.83da5149.jpg";